import createApiRequester from '../../../api/apiRequester'
import environment from '../../../config'
const requester = createApiRequester(environment.apis.registry.v1)

const userService = {
  changeUserProfile: async (role: string): Promise<void> => {
    const result = await requester.post('users:change-role', {
      role,
    })

    if (!result.problem) return

    return Promise.reject(result.problem)
  },
}

export default userService
